module.exports = __webpack_public_path__ + "static/media/6masala-mb-fr.c1dc7096.jpg";